module.exports = __webpack_public_path__ + "static/media/herzing_logo.456a567f.png";